<ion-split-pane contentId="main">
  <ion-progress-bar
    *ngIf="tenantLoading$ | async"
    type="indeterminate"
    color="primary"
    class="tenant-loading-bar"
  />
  <ion-menu contentId="main" type="push" #mobileMenu class="menu">
    <ion-content>
      <!-- <div class="side-menu-loading" *ngIf="isLoading; else content">
        <ion-spinner name="lines-sharp-small" />
      </div> -->

      <app-user-switcher />

      <ng-container *ngIf="tenant$ | async as tenant">
        <ng-container *ngIf="userRoleStatus$ | async as userRoleStatus">
          <ng-container
            *ngIf="googleReviewsEnabled$ | async as googleReviewsEnabled"
          >
            <ng-container
              *ngIf="
                attendanceApprovalsEnabled$
                  | async as attendanceApprovalsEnabled
              "
            >
              <ul class="side-menu level-0">
                <li>
                  <a
                    [routerLink]="'/i/' + tenant._id + '/recognition'"
                    routerLinkActive="active"
                    class="menu-item"
                    [appMenuClose]="mobileMenu"
                    appHaptics
                  >
                    <ion-icon name="happy-outline" />
                    <ion-icon name="happy" class="active-item-icon" />
                    Recognition
                  </a>
                </li>
                <li *ngIf="tenant.features.checklist">
                  <a
                    [routerLink]="'/i/' + tenant._id + '/checklist'"
                    routerLinkActive="active"
                    class="menu-item"
                    [appMenuClose]="mobileMenu"
                    appHaptics
                  >
                    <ion-icon name="checkmark-circle-outline" />
                    <ion-icon
                      name="checkmark-circle"
                      class="active-item-icon"
                    />
                    Checklist
                  </a>
                </li>
                <li *ngIf="tenant.features.tags">
                  <a
                    [routerLink]="'/i/' + tenant._id + '/tags'"
                    routerLinkActive="active"
                    class="menu-item"
                    [appMenuClose]="mobileMenu"
                    appHaptics
                  >
                    <ion-icon name="pricetags-outline" />
                    <ion-icon name="pricetags" class="active-item-icon" />
                    Tags
                  </a>
                </li>
                <li
                  *ngIf="
                    tenant.features.insights ||
                    tenant.features.surveyFeedback ||
                    attendanceApprovalsEnabled.value ||
                    googleReviewsEnabled.value ||
                    tenant.features.calculateRewards
                  "
                >
                  <div
                    class="menu-group-header"
                    (click)="toggleSubmenu(openedSubmenuType.PERFORMANCE)"
                    [ngClass]="{
                      'menu-group-header--opened':
                        openedMenu === openedSubmenuType.PERFORMANCE
                    }"
                    appHaptics
                  >
                    <div class="menu-item">
                      <ion-icon name="stats-chart-outline" />
                      Performance
                      <ng-container
                        *ngIf="
                          hasAnyPerformanceAttention$
                            | async as hasAnyPerformanceAttention
                        "
                      >
                        <span
                          class="attention-dot"
                          *ngIf="
                            hasAnyPerformanceAttention.value &&
                            openedMenu !== openedSubmenuType.PERFORMANCE
                          "
                        ></span>
                      </ng-container>

                      <ion-icon name="chevron-down" class="open-icon" />
                    </div>
                  </div>
                </li>

                <ul
                  *ngIf="
                    tenant.features.insights ||
                    tenant.features.surveyFeedback ||
                    attendanceApprovalsEnabled.value ||
                    googleReviewsEnabled.value ||
                    tenant.features.calculateRewards
                  "
                  class="side-menu level-next"
                  [@submenuInOut]="
                    openedMenu === openedSubmenuType.PERFORMANCE ? 'in' : 'out'
                  "
                  [ngClass]="{
                    'level-next--opened':
                      openedMenu === openedSubmenuType.PERFORMANCE,
                    'level-next--closed':
                      closedMenu === openedSubmenuType.PERFORMANCE
                  }"
                >
                  <li>
                    <a
                      [routerLink]="'/i/' + tenant._id + '/performance'"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{
                        paths: 'exact',
                        queryParams: 'exact',
                        matrixParams: 'ignored',
                        fragment: 'ignored'
                      }"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="pie-chart-outline" />
                      <ion-icon name="pie-chart" class="active-item-icon" />
                      Points
                    </a>
                  </li>
                  <li
                    *ngIf="
                      tenant.features.surveyFeedback &&
                      !(currentUser$ | async)?.isInsightsHidden
                    "
                  >
                    <a
                      [routerLink]="
                        '/i/' + tenant._id + '/psychological-survey-feedback'
                      "
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="star-half-outline" />
                      <ion-icon name="star-half" class="active-item-icon" />
                      Feedback
                    </a>
                  </li>
                  <li *ngIf="userRoleStatus.isAdminOrManager">
                    <a
                      [routerLink]="'/i/' + tenant._id + '/approvals'"
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="stopwatch-outline" />
                      <ion-icon name="stopwatch" class="active-item-icon" />
                      Time Attack
                      <ng-container
                        *ngIf="
                          waitingForApprovalsTaskPerformances$
                            | async as waitingForApprovalsTaskPerformances
                        "
                      >
                        <div
                          class="unread-count"
                          *ngIf="waitingForApprovalsTaskPerformances.length"
                        >
                          {{ waitingForApprovalsTaskPerformances.length }}
                        </div>
                      </ng-container>
                    </a>
                  </li>
                  <li *ngIf="attendanceApprovalsEnabled.value">
                    <a
                      [routerLink]="
                        '/i/' + tenant._id + '/attendance-approvals'
                      "
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="time-outline" />
                      <ion-icon name="time" class="active-item-icon" />
                      Attendance
                      <div
                        class="unread-count"
                        *ngIf="
                          pendingAttendanceBonusesLength$
                            | async as pendingAttendanceBonusesLength
                        "
                      >
                        {{ pendingAttendanceBonusesLength }}
                      </div>
                    </a>
                  </li>
                  <li *ngIf="googleReviewsEnabled.value">
                    <a
                      [routerLink]="'/i/' + tenant._id + '/google-reviews'"
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="ribbon-outline" />
                      <ion-icon name="ribbon" class="active-item-icon" />
                      Reviews
                      <ng-container
                        *ngIf="
                          pendingGoogleReviewsCount$
                            | async as pendingGoogleReviewsCount
                        "
                      >
                        <div
                          class="unread-count"
                          *ngIf="pendingGoogleReviewsCount > 0"
                        >
                          {{ pendingGoogleReviewsCount }}
                        </div>
                      </ng-container>
                    </a>
                  </li>
                  <li
                    *ngIf="
                      userRoleStatus.isAdmin && tenant.features.calculateRewards
                    "
                  >
                    <a
                      [routerLink]="'/i/' + tenant._id + '/performance'"
                      [queryParams]="{ open: 'compensation' }"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{
                        paths: 'exact',
                        queryParams: 'subset',
                        matrixParams: 'ignored',
                        fragment: 'ignored'
                      }"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="calculator-outline" />
                      <ion-icon name="calculator" class="active-item-icon" />
                      Compensation
                    </a>
                  </li>
                </ul>
                <li *ngIf="tenant.features.announcements">
                  <a
                    [routerLink]="'/i/' + tenant._id + '/announcements'"
                    routerLinkActive="active"
                    class="menu-item"
                    [appMenuClose]="mobileMenu"
                    appHaptics
                  >
                    <ion-icon name="mail-outline" />
                    <ion-icon name="mail" class="active-item-icon" />
                    Announcements
                    <ng-container
                      *ngIf="
                        unreadAnnouncementsCount$
                          | async as unreadAnnouncementsCount
                      "
                    >
                      <div
                        *ngIf="unreadAnnouncementsCount > 0"
                        class="unread-count"
                      >
                        {{ unreadAnnouncementsCount }}
                      </div>
                    </ng-container>
                  </a>
                </li>
                <li *ngIf="tenant.features.suggestions">
                  <a
                    [routerLink]="'/i/' + tenant._id + '/suggestions'"
                    routerLinkActive="active"
                    class="menu-item"
                    [appMenuClose]="mobileMenu"
                    appHaptics
                  >
                    <ion-icon name="chatbubbles-outline" />
                    <ion-icon name="chatbubbles" class="active-item-icon" />
                    Suggestions
                  </a>
                </li>
                <li *ngIf="tenant.features.library">
                  <a
                    [routerLink]="'/i/' + tenant._id + '/library'"
                    routerLinkActive="active"
                    class="menu-item"
                    [appMenuClose]="mobileMenu"
                    appHaptics
                  >
                    <ion-icon name="library-outline" />
                    <ion-icon name="library" class="active-item-icon" />
                    Library
                  </a>
                </li>
                <li>
                  <div
                    class="menu-group-header"
                    (click)="toggleSubmenu(openedSubmenuType.SETTINGS)"
                    appHaptics
                    [ngClass]="{
                      'menu-group-header--opened':
                        openedMenu === openedSubmenuType.SETTINGS
                    }"
                  >
                    <div class="menu-item">
                      <ion-icon name="settings-outline" />
                      Settings
                      <ion-icon name="chevron-down" class="open-icon" />
                    </div>
                  </div>
                </li>

                <ul
                  class="side-menu level-next"
                  [@submenuInOut]="
                    openedMenu === openedSubmenuType.SETTINGS ? 'in' : 'out'
                  "
                  [ngClass]="{
                    'level-next--opened':
                      openedMenu === openedSubmenuType.SETTINGS,
                    'level-next--closed':
                      closedMenu === openedSubmenuType.SETTINGS
                  }"
                >
                  <li>
                    <a
                      [routerLink]="'/i/' + tenant._id + '/profile'"
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="person-circle-outline" />
                      <ion-icon name="person-circle" class="active-item-icon" />
                      Account Settings
                    </a>
                  </li>
                  <li [attr.data-hidden]="!userRoleStatus.isAdminOrManager">
                    <a
                      [routerLink]="'/i/' + tenant._id + '/team-settings'"
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="hammer-outline" />
                      <ion-icon name="hammer" class="active-item-icon" />
                      Team Settings
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="'/i/' + tenant._id + '/users'"
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="people-outline" />
                      <ion-icon name="people" class="active-item-icon" />
                      Users
                    </a>
                  </li>
                  <li *ngIf="isSuperAdmin">
                    <a
                      [routerLink]="'/i/' + tenant._id + '/developer'"
                      routerLinkActive="active"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="code-outline" />
                      <ion-icon name="code" class="active-item-icon" />
                      Developer
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      (click)="logoutUser($event)"
                      class="menu-item"
                      [appMenuClose]="mobileMenu"
                      appHaptics
                    >
                      <ion-icon name="log-out-outline" />
                      Logout
                    </a>
                  </li>
                  <li>
                    <div
                      class="menu-item menu-item--no-icon menu-item--disabled"
                    >
                      v{{ appVersion }}
                    </div>
                  </li>
                </ul>
              </ul>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ion-content>
  </ion-menu>

  <div id="main" class="ion-page">
    <router-outlet />
  </div>
</ion-split-pane>
